const STRUCTURE_KEYS = ['parent', 'title', 'url', 'summary', 'children', 'attributes'];
export default class DeepMenuController extends Classy {
  constructor() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let structure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    // The site tree data
    this.data = data;
    // The current depth as an array of menu sets
    this.depth = [this.data];
    // The parent
    this.parents = [];
    // The open state
    this.isOpen = false;

    // Create a structure object from the array of keys
    this.structure = STRUCTURE_KEYS.reduce((obj, key) => {
      // Set the key to the value in the passed in structure object or the key itself
      obj[key] = structure[key] || key;
      return obj;
    }, {});
  }
  getDepth() {
    return this.depth.length - 1;
  }
  getParent() {
    return this.parents[this.parents.length - 1];
  }
  render() {
    // Grab the structure in a more readable format
    const structure = this.structure;
    // Grab the last item in the depth array
    const data = this.depth[this.depth.length - 1];
    this.callback('render', data.map(item => {
      return {
        title: item[structure.title],
        url: item[structure.url],
        summary: item[structure.summary],
        attributes: item[structure.attributes],
        children: item[structure.children],
        callback: () => {
          this.parents.push(item);
          this.depth.push(item[structure.children]);
          this.render();
        }
      };
    }));
  }
  back() {
    // If there is only one menu in the depth array, we are at the top level so call the close method
    if (this.depth.length <= 1) return this.close();

    // Remove the last item from the depth array
    this.depth.pop();
    // Remove the last item from the parents array
    this.parents.pop();

    // Render the menu
    this.render();

    // The back callback
    this.callback('back');
  }
  reset() {
    // Reset the depth to the top level
    this.depth = [this.data];
    // Reset the parent
    this.parents.length = 0;
    // Render the menu
    this.render();

    // The reset callback
    this.callback('reset');
  }
  close() {
    // Set the open state to false
    this.isOpen = false;
    // Reset the menu to the top level
    this.reset();
    // The close callback
    this.callback('close');
  }
  open() {
    let render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // Set the open state to true
    this.isOpen = true;
    // Render the menu at the top level
    if (this.depth.length != 1) this.reset();
    // Render the menu
    if (render) this.render();
    // The open callback
    this.callback('open');
  }
}